import { useTranslation } from "react-i18next";
import { NavLink } from "react-router";

import { Sidebar } from "@digital-services/ui";

interface NavigationItem {
  icon: React.ReactNode;
  label: string;
  id: string;
  url?: string;
  onMenuClick?: () => void;
  target?: string;
}

export const Navigation = ({ items }: { items: NavigationItem[] }) => {
  const { t } = useTranslation();

  return (
    <nav className="flex h-full flex-col justify-between">
      {items.map(({ icon, id, label, target, url, onMenuClick }) => (
        <NavLink
          key={`navigation-${id}`}
          to={url ?? ""}
          target={target}
          data-testid={`navigation-${id}`}
          onClick={() => (onMenuClick ? onMenuClick() : undefined)}
        >
          {({ isActive }) => (
            <Sidebar.MenuItem
              icon={icon}
              label={t(label)}
              isActive={isActive}
            />
          )}
        </NavLink>
      ))}
    </nav>
  );
};
